<template>
  <div id="contenedor">
    <v-layout row wrap="">
      <v-flex xs12 sm12 md12>
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
              <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-magnify</v-icon
              >
            </v-card>
            <div class="usuario">CONSULTAR TICKETS</div>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container fluid class="mt-5">
            <v-row>
              <v-col cols="12" sm="4">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="dates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dates"
                      label="Selecciona el rango de fechas para consultar tickets "
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="es-es"
                    range
                    v-model="dates"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="consultarIncidentes(dates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn
                  :loading="loading"
                  color="blue darken-4"
                  tile
                  dark
                  class="mt-1"
                  @click="buscarIncidentes()"
                >
                  <v-icon> mdi-magnify </v-icon>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar Ticket"
            single-line
            class="text-field"
            color="#111c3d"
          ></v-text-field>
          <br />
          <v-data-table
            :headers="headers"
            :items="incidentes"
            :search="search"
            style="border: 2px solid #111c3d"
            class="elevation-3"
          >
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <template v-slot:[`item.action`]="{ item }">
              <v-icon
                color="light-blue darken-4"
                class="mr-2"
                @click="verConversacion(item)"
              >
                mdi-wechat
              </v-icon>
              <v-icon
                color="light-green lighten-1"
                class="mr-2"
                @click="verObservacion(item)"
              >
                mdi-eye
              </v-icon>
              <v-icon
                v-if="item.cc_ruta !== ''"
                color="light-blue"
                class="mr-2"
                @click="verImagen(item)"
              >
                mdi-image
              </v-icon>
              <v-icon
                v-if="[0, 2, 3, 4].includes(Number(item.cerrados))"
                color="light-blue"
                class="mr-2"
                @click="cambiarEstado(item)"   
              >
                mdi-card-bulleted-off
              </v-icon>
              <v-icon color="purple" class="mr-2" @click="verHistorialObservaciones(item)">
                mdi-comment-multiple-outline
              </v-icon>
            </template>
            <template v-slot:[`item.cerrados`]="{ item }">
                {{ estadoCerradoTexto(item.cerrados) }}
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
                >No se encontro su busqueda</v-alert
              >
            </template>
          </v-data-table>
          <!-- Dialog que permite visualizar la conversacion -->
          <v-dialog v-model="dialog2" max-width="500px" persistent>
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white"
                  ><v-icon color="white">mdi-message-bulleted</v-icon>
                  Conversación</span
                >
              </v-card-title>
              <!-- componente del modal para agregar y actualizar -->
              <v-card-text>
                <div v-for="(chat, index) in chatItem" :key="index">
                  <v-card class="mt-3 mx-auto" width="550">
                    <v-card-subtitle v-if="chat.user == 'NOVA'" class="pb-0">
                      <p class="indigo--text text--darken-3">
                        <v-icon color="indigo darken-4" class="ml-5 mr-1"
                          >mdi-robot</v-icon
                        >{{ chat.user }}
                      </p>
                    </v-card-subtitle>
                    <v-card-subtitle v-else class="d-flex justify-end">
                      <p class="deep-purple--text text--accent-3">
                        <v-icon color="deep-purple accent-4" class="ml-5 mr-1"
                          >mdi-face</v-icon
                        >{{ chat.user }}
                      </p>
                    </v-card-subtitle>
                    <v-card-text v-if="chat.user == 'NOVA'" class="">
                      <p class="grey--text text--darken-1 text-left chat-message">
                        {{ chat.message }}
                      </p>
                    </v-card-text>
                    <v-card-text v-else class="d-flex justify-end">
                      <p class="grey--text text--darken-1 text-right chat-message">
                        {{ chat.message }}
                      </p>
                    </v-card-text>
                  </v-card>
                </div>
                <v-divider class="mt-5"></v-divider>
              </v-card-text>
              <!-- botones para cancelar y agregregar y validacion de campos vacios -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="verEvidencias(idCasoActual)" class="mr-2">
                    <v-icon left>mdi-image-multiple</v-icon>
                    VER EVIDENCIAS
                  </v-btn>
                <v-btn color="#1D3C7F" dark @click="close2">CERRAR</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Dialog que permite ver las observaciones -->
          <v-dialog v-model="dialog3" max-width="500px" persistent>
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white"
                  ><v-icon color="white">mdi-message-bulleted</v-icon>
                  Observacion del caso</span
                >
              </v-card-title>
              <!-- componente del modal para agregar y actualizar -->
              <v-card-text class="pa-5">
                <p style="font-size: 18px">
                  {{
                    observacion
                      ? observacion
                      : "No se ingreso una observación para este caso"
                  }}
                </p>
              </v-card-text>
              <!-- botones para cancelar y agregregar y validacion de campos vacios -->
              <v-card-actions>
                <v-spacer></v-spacer>
                
                <v-btn color="#1D3C7F" dark @click="close3">CERRAR</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Dialog que permite ver las imagnes -->
          <v-dialog v-model="dialog4" max-width="500px" max-height="400px" persistent>
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white"
                  ><v-icon color="white">mdi-image</v-icon>
                  Evidencia del Caso</span
                >
              </v-card-title>
              <!-- componente del modal para agregar y actualizar -->
              <v-card-text class="pa-5">
                <p style="font-size: 18px">
                  
                    <v-img v-if="cc_ruta" :src="cc_ruta" alt="Imagen"></v-img>
                    
                </p>
              </v-card-text>
              <!-- botones para cancelar y agregregar y validacion de campos vacios -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#294697" dark @click="dialog4 = false">CERRAR</v-btn>
                <v-btn color="#1D3C7F" dark @click="aumentarImagen">Aumentar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Dialog para ver la imagen aumentada -->
          <v-dialog v-model="dialogImagenCompleta" max-width="90vw" fullscreen>
            <v-card flat>
              <v-toolbar dark color="#1D3C7F" flat>
                <v-btn icon dark @click="descargarImagen">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <v-toolbar-title>Evidencia</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialogImagenCompleta = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text class="pa-0 d-flex justify-center align-center" style="height: calc(100vh - 64px); background-color: #000;">
                <img :src="imagenSeleccionada" style="max-height: 95vh; max-width: 95vw; object-fit: contain;" />
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog6" max-width="500px" persistent>
            <v-card>
              <v-card-title class="headline" style="color: white; background-color: #1D3C7F;">
                <v-icon color="white" class="mr-2">mdi-alert</v-icon>
                    Confirmación
              </v-card-title>

              <v-card-text class="text-subtitle-1 pt-4">
                ¿Por qué desea anular el ticket?
                <v-textarea
                  v-model="editedItem.observacion"
                  label="Escriba la razón"
                  rows="3"
                  outlined
                  class="mt-4"
                ></v-textarea>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#294697" text @click="dialog6 = false">Cancelar</v-btn>
                <v-btn color="#1D3C7F" text @click="guardarEstado" :disabled="!editedItem.observacion || editedItem.observacion.trim() === ''">Guardar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
            color="#3945d0"
            style="color: white"
          >
            {{ text }}
            <v-btn color="#3945d0" depressed @click="snackbar = false"
              >Cerrar</v-btn
            >
          </v-snackbar>
                    
          <!-- Modal para ver las evidencias del caso -->
          <v-dialog v-model="dialogEvidencias" max-width="900px">
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-image-multiple</v-icon>
                  Evidencias del caso #{{ idCasoActual }}
                </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <div v-if="cargandoEvidencias" class="text-center my-5">
                    <v-progress-circular indeterminate color="#294697"></v-progress-circular>
                    <p>Cargando evidencias...</p>
                  </div>
                  <div v-else-if="!Array.isArray(evidencias) || evidencias.length === 0" class="text-center my-5">
                    <v-alert type="info" outlined>
                      No hay evidencias disponibles para este caso.
                    </v-alert>
                  </div>
                  <v-row v-else>
                    <v-col v-for="(evidencia, index) in evidencias" :key="index" cols="12" sm="6" md="4">
                      <v-card outlined>
                        <template v-if="isImageUrl(evidencia.cc_ruta_evidencia)">
                          <v-img
                            :src="evidencia.cc_ruta_evidencia"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            @click="verImagenCompleta(evidencia.cc_ruta_evidencia)"
                            style="cursor: pointer"
                          >
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="#294697"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </template>
                        <template v-else>
                          <v-card
                            class="d-flex flex-column align-center justify-center pa-3"
                            style="cursor: pointer; aspect-ratio: 1; height: 100%;"
                            @click="downloadFile(evidencia.cc_ruta_evidencia)"
                          >
                            <v-icon size="80" color="grey darken-1">mdi-file-document-outline</v-icon>
                            <div class="mt-2 text-caption grey--text text--darken-1 text-center" style="word-break: break-all;">
                              {{ getFileName(evidencia.cc_ruta_evidencia) }}
                            </div>
                          </v-card>
                        </template>
                        <v-card-text class="pa-2">
                          <small class="grey--text">{{ formatDate(evidencia.fecha_subida) }}</small>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="closeEvidencias">CERRAR</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <CaseHistoryTimeline
            v-if="idCasoActual !== null"
            :caseId="idCasoActual"
            :visible.sync="dialogHistorialObservaciones"
            :soloObservaciones="true"
          />
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import env from "../../env";
import SemaforoTiempo from "../Especialista/SemaforoTiempo.vue";
import CaseHistoryTimeline from '../Especialista/CaseHistoryTimeline.vue';

export default {
  components: {
    SemaforoTiempo,
    CaseHistoryTimeline
  },
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      /* fechaN:false,
      fechaI:false, */
      cc_ruta: "",  
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      incidentes: [],
      chatItem: [],
      observacion: "",
      dates: ["", ""],
      menu: false,
      dialog4: false,
      dialog3: false,
      dialog6: false,
      headers: [
        {
          text: "Id",
          align: "left",
          value: "cc_id_caso",
          align: "center",
          class: "column",
        },
        {
          text: "Asesor",
          value: "nombre",
          align: "center",
          class: "column",
        },
        {
          text: "Area",
          value: "cc_nombre_area",
          align: "center",
          class: "column",
        },
        {
          text: "Requerimiento",
          value: "cc_nombre_requerimiento",
          align: "center",
          class: "column",
        },
        {
          text: "Fecha Inicio",
          value: "fecha_inicio",
          align: "center",
          class: "column",
        },
        {
          text: "Fecha Cierre",
          value: "fecha_cierre",
          align: "center",
          class: "column",
        },
        {
          text: "Estado",
          value: "cerrados",
          align: "center",
          class: "column",
        },
        
        {
          text: "Acciones",
          value: "action",
          align: "center",
          class: "column",
          sortable: false,
        },
      ],
      defaultItem: {
        idArea: "",
        areas: "",
      },
      editedIndex: -1,
      editedItem: {
        idArea: "",
        areas: "",
      },
      dialog2: false,
      dialog3: false,
      fechaInicio: "",
      fechaActual: "",
      loading: false,
      requerimientosInfo: {},
      dialogEvidencias: false,
      dialogImagenCompleta: false,
      evidencias: [],
      cargandoEvidencias: false,
      imagenSeleccionada: '',
      idCasoActual: null,
      dialogHistorialObservaciones: false,
    };
  },
  created() {
    localStorage.removeItem("sala");
    localStorage.removeItem("requerimiento");
    this.obtenerFechas();
    this.obtenerIncidentes(this.fechaInicio, this.fechaActual);
  },
  methods: {
    obtenerFechas() {
      const date = new Date();
      this.fechaInicio = new Date(date.getFullYear(), date.getMonth(), 1);
      this.fechaInicio = this.fechaInicio.toISOString().substr(0, 10);
      this.fechaActual = new Date().toISOString().substr(0, 10);
      this.dates = [this.fechaInicio, this.fechaActual];
    },

    /**
     * Metodo para obtener los incidentes en la fecha inical del mes y la fecha actual
     */
    obtenerIncidentes(fechaInicial, fechaFinal) {
      // Primero obtenemos los datos de requerimientos para tener los tiempos máximos
      axios
        .get(`${env.endpoint}callcenter/requerimientostodos?idUsuario=${localStorage.getItem("id")}`)
        .then((res) => {
          // Crear diccionario de requerimientos para acceso rápido
          this.requerimientosInfo = {};
          res.data.forEach(req => {
            this.requerimientosInfo[req.cc_id_requerimientos] = req;
          });
          
          // Luego obtenemos los incidentes
          axios
            .get(
              `${
                env.endpoint
              }callcenter/incidentesasesor?idUsuario=${localStorage.getItem(
                "id"
              )}&fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}`
            )
            .then((res) => {
              // console.log('Estados originales de los casos:', res.data.map(item => ({
              //   id: item.cc_id_caso,
              //   estado: item.cerrados,
              //   estadoTexto: this.estadoCerradoTexto(item.cerrados)
              // })));  // debug para ver los estados originales de los casos
              
              // Asignamos los incidentes directamente sin modificar su estado
              this.incidentes = res.data;
            });
        });
    },
    /**
     * Metodo para buscar indicentes por rango de fechas
     */
    buscarIncidentes() {
      if (this.dates.length == 2) {
        this.loading = true;
        if (this.dates[0] > this.dates[1]) {
          let temp = this.dates[0];
          this.dates[0] = this.dates[1];
          this.dates[1] = temp;
        }
        
        // Primero obtenemos los datos de requerimientos para tener los tiempos máximos
        axios
          .get(`${env.endpoint}callcenter/requerimientostodos?idUsuario=${localStorage.getItem("id")}`)
          .then((res) => {
            // Crear diccionario de requerimientos para acceso rápido
            this.requerimientosInfo = {};
            res.data.forEach(req => {
              this.requerimientosInfo[req.cc_id_requerimientos] = req;
            });
            
            // Luego obtenemos los incidentes según fechas
            axios
              .get(
                `${
                  env.endpoint
                }callcenter/incidentesasesor?idUsuario=${localStorage.getItem(
                  "id"
                )}&fechaInicial=${this.dates[0]}&fechaFinal=${this.dates[1]}`
              )
              .then((res) => {
                // console.log('Estados originales de los casos (buscarIncidentes):', res.data.map(item => ({
                //   id: item.cc_id_caso,
                //   estado: item.cerrados,
                //   estadoTexto: this.estadoCerradoTexto(item.cerrados)
                // }))); // debug para ver los estados originales de los casos
                
                // Asignamos los incidentes directamente sin modificar su estado
                this.incidentes = res.data;
                this.loading = false;
              });
          });
      } else {
        this.text =
          "Seleccione por favor dos fechas, de lo contrario no podra filtrar los resultados";
        this.snackbar = true;
      }
    },
    consultarIncidentes(dates) {
      this.$refs.menu.save(dates);
    },
    /**
     * Metodo para cerrar la modal de ver conversacion
     */
    close2() {
      this.dialog2 = false;
      setTimeout(() => {
        this.editedItem = this.defaultItem;
        this.editedIndex = -1;
      }, 300);
    },
    close3() {
      this.dialog3 = false;
    },


    verConversacion(item) {
      // console.log("se imprime el item ", item);
      this.dialog2 = true;
      this.idCasoActual = item.cc_id_caso;

      const data = JSON.parse(JSON.stringify(item));
      this.chatItem = JSON.parse(data.conversacion);
    },
    verObservacion(item) {
      this.dialog3 = true;
      this.observacion = item.observaciones;
    },
    verImagen(item) {
      this.dialog4 = true;
      this.cc_ruta = item.cc_ruta;
    },
    aumentarImagen() {
      this.imagenSeleccionada = this.cc_ruta;
      this.dialog4 = false;
      this.dialogImagenCompleta = true;
    },
    descargarImagen() {
      const link = document.createElement('a');
      link.href = this.imagenSeleccionada;
      link.download = this.imagenSeleccionada.split('/').pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    estadoCerradoTexto(codigo) {
      switch (codigo) {
        case "1":
          return "SOLUCIONADO"; //Son aquellas solicitudes que son atendidas en los tiempos establecidos y de manera oportuna.
        case "2":
          return "ASIGNADO"; //Son aquellos que se encuentran en proceso o a la espera de la solución.
        case "3":
          return "SUSPENDIDO"; //Son aquellos casos que su respuesta depende de un tercero como SuperGiros, Datacenter, entre otros.
        case "4":
          return "VENCIDO"; //Son aquellos que exceden el tiempo de respuesta parametrizado en el software, el hecho de que se encuentren en estado de vencimiento, no significa que no se otorgue una respuesta a la solicitud.
        case "5":
          return "ANULADO"; //Son aquellos que después de reportados, ya no son requeridos por el funcionario solicitante.
        case "0":
        default:
          return "ABIERTO"; //Son aquellos que se encuentran sin asignar a algún funcionario de la mesa de servicio. Disponibles para ser tomados y gestionados.
      }
    },
    /**
     * Maneja el evento cuando el estado de un caso cambia automáticamente a VENCIDO
     */
    handleCasoVencido({ idCaso, mensaje }) {
      // Buscar el caso actual en los incidentes
      const casoActual = this.incidentes.find(inc => inc.cc_id_caso == idCaso);
      
      // Si el caso ya está anulado (estado 5), no hacer nada
      if (casoActual && casoActual.cerrados == 5) {
        // console.log(`El caso #${idCaso} está anulado (estado 5), no se cambiará a vencido.`);
        return;
      }
      
      // Actualizar la lista de incidentes
      this.obtenerIncidentes(this.fechaInicio, this.fechaActual);
      
      // Mostrar mensaje de notificación
      this.text = mensaje;
      this.snackbar = false;
    },
    /**
     * Método para obtener y mostrar las evidencias de un caso
     */
     verEvidencias(idCaso) {
      this.idCasoActual = idCaso;
      this.dialogEvidencias = true;
      this.cargandoEvidencias = false;
      this.evidencias = [];
      
      // enpoint para traer imagenes al modal chat 
      axios.get(`${env.endpointTraerEvidencias}?cc_id_caso=${idCaso}`)
        .then(response => {
          this.evidencias = response.data.evidencias;
          // console.log(response.data.evidencias);
        })
        .catch(error => {
          console.error('Error al cargar evidencias:', error);
          this.text = "Error al cargar las evidencias";
          this.snackbar = true;
        })
        .finally(() => {
          this.cargandoEvidencias = false;
        });
    },
    
    /**
     * Método para cerrar el modal de evidencias
     */
    closeEvidencias() {
      this.dialogEvidencias = false;
      this.evidencias = [];
    },
    
    /**
     * Método para ver una imagen en pantalla completa
     */
     verImagenCompleta(url) {
      this.imagenSeleccionada = url;
      if (this.dialogEvidencias) this.dialogEvidencias = false;
      if (this.dialog4) this.dialog4 = false;
      this.dialogImagenCompleta = true;
    },
    
    /**
     * Método para formatear la fecha de la evidencia
     */
    formatDate(dateString) {
      const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
      return new Date(dateString).toLocaleDateString('es-ES', options);
    },

    cambiarEstado(item){
      this.editedItem = { ...item };
      this.dialog6 = true;
      this.idCaso = item.cc_id_caso;
    },
    guardarEstado() {
      const estadoNumero = 5;
      const accion = 8; // Código para ANULADO
      const observacion = encodeURIComponent(this.editedItem.observacion || '');

      axios.get(`${env.endpoint}callcenter/cambiarEstado?idCaso=${this.idCaso}&cerrados=${estadoNumero}&observacion=${observacion}`)
        .then((res) => {
          if (res.data.estado) {
            this.text = "Estado cambiado correctamente";
            
            // Registrar la acción en el historial
            axios.post(`${env.endpoint}historial/registrar_accion`, {
              cc_id_caso: this.idCaso,
              accion: accion,
              idUsuario: localStorage.getItem("id"),
              observaciones: this.editedItem.observacion || ""
            }).catch((error) => {
              console.error("Error al registrar la acción en el historial:", error);
            });
          } else {
            this.text = "Este caso no pudo cambiar de estado";
          }
          this.snackbar = true;
          this.close6();
          this.obtenerIncidentes(this.fechaInicio, this.fechaActual);
        })
        .catch((error) => {
          this.text = "Error al cambiar estado";
          this.snackbar = true;
          console.error(error);
        });
    },
    close6() {
      this.dialog6 = false;
    },
    isImageUrl(url) {
      if (!url) return false;
      return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
    },
    getFileName(url) {
      if (!url) return 'Archivo';
      try {
        const fullPath = new URL(url).pathname;
        return fullPath.substring(fullPath.lastIndexOf('/') + 1);
      } catch (e) {
        // Fallback para rutas relativas o nombres simples
        const parts = url.split('/');
        return parts[parts.length - 1] || 'Archivo';
      }
    },
    downloadFile(url) {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', this.getFileName(url));
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    verHistorialObservaciones(item) {
      this.idCasoActual = item.cc_id_caso;
      this.dialogHistorialObservaciones = true;
    },
  },
};
</script>
<style>
  @media (max-width: 600px) {
  #contenedor .table {
    max-height: 638px; /* ajusta la altura máxima según tu necesidad */
    overflow-y: auto;
  }
}
.chat-message {
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-width: 100%;
}
</style>